















































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { Circle2 } from "vue-loading-spinner";
import { Modal } from "@/components"

import EspressoAux from '../../components/Espresso/EspressoAux.vue';

export interface FooterExtraButtonProps { actionText: string; class: string, onClick: () => Promise<void> }

@Component({ components: { Modal, Circle2 } })
export default class ModalTabs extends Vue {
	@Prop() private tabs: any[];
	@Prop() private error: string;
	@Prop()	private loading: boolean;
	@Prop({ default: true }) private enableAction: boolean;
	@Prop() private isCreation: boolean;
	@Prop({ default: false }) private readOnly: boolean;

	@Prop() private footerExtraButtons: FooterExtraButtonProps[];

	private footerExtraButtonsLoadingStates: boolean[] = [];

	private displayModal = true;
	private activeTabIndex = 0;
	private auditNotes = "";
	private isExecutingAction = false;

	mounted() {
		this.footerExtraButtonsLoadingStates = this.footerExtraButtons?.map(() => false);
	}

	clearNotes() {
		this.auditNotes = "";
	}

	actionCompleted() {
		this.isExecutingAction = false;
	}

	switchTab(tabIndex: number) {
		this.activeTabIndex = tabIndex;
	}

	close() {
		this.$emit("close");
	}

	getTabSlotName(index: number) {
		return `modal-tab-${index + 1}`;
	}

	get activeTab() {
		return this.tabs[this.activeTabIndex];
	}

	get actionKind() {
		return this.activeTab.icon;
	}

	get actionText() {
		if (this.activeTab.actionName) {
			if (this.activeTab.actionName instanceof Function) {
				return this.activeTab.actionName();
			}
			return this.activeTab.actionName;
		}
		if (this.actionKind === "delete") {
			return "Excluir";
		}
		if (this.isCreation) {
			return "Inserir";
		}
		return "Atualizar";
	}

	get actionClass() {
		return {
			"md-success": this.actionKind !== "delete",
			"md-danger": this.actionKind === "delete",
		};
	}

	get filteredTabs() {
		if (this.isCreation) {
			return this.tabs.filter((tab: any) => tab.creation);
		}
		return this.tabs;
	}

	get showFooter() {
		const actionAllowedWhenReadOnly = this.activeTab.allowActionWhenReadOnly === true;
		const result = this.$route.meta.permissionType === 'READ_WRITE' && (!this.readOnly || this.actionKind === 'delete' || actionAllowedWhenReadOnly);
		return result;
	}

	async actionClick() {
		this.isExecutingAction = true;
		if (this.activeTab.action) {
			return this.activeTab.action();
		}
		if (this.actionKind === "delete" && !(await EspressoAux.showConfirmationModal('Confirma a exclusão do registro?')).value) {
			this.isExecutingAction = false;
			return;
		}
		if (this.actionKind === "delete") {
			this.isExecutingAction = false;
			return this.$emit("delete");
		}
		if (this.isCreation) {
			this.isExecutingAction = false;
			return this.$emit("create");
		}
		this.isExecutingAction = false;
		return this.$emit("update");
	}

	async handleExtraButtonClick(buttonActionHandler: () => Promise<void>, buttonPositionInExtraButtonsArray: number) {
		this.footerExtraButtonsLoadingStates[buttonPositionInExtraButtonsArray] = true;
		this.$forceUpdate();

		buttonActionHandler().finally(() => {
			this.footerExtraButtonsLoadingStates[buttonPositionInExtraButtonsArray] = false;
			this.$forceUpdate();
		})
	}

	@Watch("auditNotes")
	changeNotes() {
		this.$emit("updateNotes", this.auditNotes);
	}
}
